import { MutableRefObject, useEffect, useRef, useState } from "react"
import { HxChildMap } from "../HxMap/HxChildMap"
import { Note } from "../../Data/HexMap/Note"
import { Chords } from "../../Util/Music/Chords"
import { NotesSelect } from "../NoteButtons/NotesSelect"
import { ToggleSlider } from "react-toggle-slider"
import './HexPlayer.scss'
import colors from './HexPlayer.module.scss'
import { ClassNames } from "../../Util/ClassNames"
import { useNotePlayer } from "../../Sound/SoundStore"
import { NotePlayer } from "../../Sound/NotePlayer"

export class HexPlayerModes{
    static Notes:number = 0
    static Chords:number = 1
}
export function HexPlayer(props:{playMode:number, tonic:number}){
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    const [tonic, setTonic] = useState(props.tonic)
    const [playMode, setPlayMode] = useState(props.playMode)
    const [resetOctave, setResetOctave] = useState(true)
    const ascendingNotes = true

    const onNoteClick = (note:Note, e:React.MouseEvent) => {
        if(playMode === HexPlayerModes.Notes){
            notePlayer.current.playNote(note.params.tonic, resetOctave)
            return
        }
        else{
            const formula:number[] = (e.metaKey) ? Chords.Formula_seventh : Chords.Formula_triad
            const notes:number[] = Chords.GetChordNoteTonics(tonic, note.params.noteIndex, formula)
            notePlayer.current.playChord(notes, !ascendingNotes)
        }
    }
    const changeTonic = (fresh_tonic:number)=>{
        setTonic(fresh_tonic)
    }
    useEffect(()=>{notePlayer.current.setTonic(tonic)}, [tonic])
    const getLabelClassNames = (mode:number, labelClass:string) => {
        const classNames:ClassNames = new ClassNames(['playmode-toggle-label', labelClass])
        if(mode === playMode){
            classNames.addClass('selected')
        }
        return classNames.toString()
    }
    const setFreshPlayMode = (mode:number) => {
        notePlayer.current.reset()
        setPlayMode(mode)
    }
    const toggleResetOctave = () => { 
        if(!resetOctave){
            notePlayer.current.reset()
        } 
        setResetOctave(!resetOctave)
    }
    return(
        <div className={'hex-player'}>
                <div style={{textAlign:'center', margin:10, marginTop:40}}>
                    Play Mode: <button type='button' onClick={()=>{setFreshPlayMode(HexPlayerModes.Chords)}} className={getLabelClassNames(HexPlayerModes.Chords, 'chords-label')}>Chords</button>
                    <button type='button' onClick={()=>{setFreshPlayMode(HexPlayerModes.Notes)}}className={getLabelClassNames(HexPlayerModes.Notes, 'notes-label')}>Notes</button>
                     { playMode === HexPlayerModes.Notes && 
                     <>
                     <div className={'auto-octave'}>
                      <div className={'auto-octave-label'}>Auto Octave Reset:</div> <div className={'toggle'}>
                            <ToggleSlider barBackgroundColorActive={colors.sliderColor} 
                                        onToggle={toggleResetOctave} 
                                        active={resetOctave}/>
                        </div>
                        {!resetOctave && <button className={'manual-reset'} type='button' onClick={()=>{notePlayer.current.reset()}}>Manually Reset Octave</button>}
                    </div>   
                    </>
                    }

                    

                </div>
                <NotesSelect tonic={tonic} onChange={changeTonic}/>
                <HxChildMap height={400} 
                            width={400} 
                            tonic={tonic} 
                            radius={120} 
                            hilitedNotes={[]}
                            onNoteClick={onNoteClick}/>
        </div>
    )
}